import { dashboardApi } from '@/api';

interface UpdateCampaignNameArgs {
    projectId: string;
    campaignId: string;
    name: string;
}

export const updateCampaignName = async ({
    projectId,
    campaignId,
    name,
}: UpdateCampaignNameArgs) => {
    await dashboardApi({
        method: 'PATCH',
        url: `/customer-campaign/project/${projectId}/campaign/${campaignId}/name`,
        data: {
            name,
        },
    });
};
